<template>
  <div v-if="isHideRevenue !== undefined" class="wrapper">
    <div v-if="isHideRevenue">本ページへのアクセス権がありません</div>
    <div v-if="!isHideRevenue">
      <BudgetProgressReportBreadCrumb class="breadCrumb" />
      <ReminderContainer :selectedData="selectedData" />
      <Section class="chart-wrapper"><Chart :chartData="chartData"/></Section>
      <Section class="table-wrapper">
        <MyTable :tableData="tableData" :middleLang="middleLang" />
      </Section>
    </div>
  </div>
</template>

<script>
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeAdvertiser } from '@/mixins/setDrawerTypeAdvertiser'
import { setToolbarTypeAdvertiser } from '@/mixins/setToolBarTypeAdvertiser'

import ReminderContainer from '@/components/Advertiser/Report/BudgetProgressReport/Reminder/ReminderContainer'
import Chart from '@/components/Advertiser/Report/BudgetProgressReport/Chart'
import MyTable from '@/components/Advertiser/Report/BudgetProgressReport/Table'

import { actions, getters } from '@/vuex/modules/progressReport/constants'
import BudgetProgressReportBreadCrumb from '@/components/Shared/BreadCrumb/BudgetProgressReportBreadCrumb'
import Section from '@/components/Shared/Section/Section'
import { Account } from '@/models/Account'

export default {
  name: 'BudgetProgress',
  components: {
    ReminderContainer,
    Chart,
    MyTable,
    BudgetProgressReportBreadCrumb,
    Section,
  },
  mixins: [
    accountInitializer,
    setDrawerTypeAdvertiser,
    setToolbarTypeAdvertiser,
  ],
  data() {
    return {
      loader: false,
      isHideRevenue: undefined,
    }
  },
  computed: {
    tableData() {
      return this.$store.getters[getters.tableData]
    },
    middleLang() {
      return this.$store.getters[getters.middleLang]
    },
    chartData() {
      return this.$store.getters[getters.chartData]
    },
    today() {
      return this.$store.getters[getters.today]
    },
    selectedIOId() {
      return this.$store.getters[getters.selectedIOId]
    },
    selectedData() {
      return this.$store.getters[getters.IOProgressData]
    },
    userBelongType() {
      return this.$store.getters['account/belongType']
    },
    userBelongId() {
      return this.$store.getters['account/belongId']
    },
    userType() {
      return this.$store.getters['account/userType']
    },
  },
  watch: {
    async userBelongType() {
      this.setIsHideRevenue()
    },
  },
  async created() {
    // TODO: loaderとは？使ってる箇所が見当たらないので後で調査して元に戻す
    // this.loader(true)
    const advertiserId = Number(this.$route.params.advertiserId)
    await this.$store.dispatch(actions.GET_INITIAL_TABLE_DATA, {
      advertiserId,
    })
    this.setIsHideRevenue()
    // this.loader(false)
  },
  methods: {
    async setIsHideRevenue() {
      if (!this.userBelongType || !this.userBelongId) return

      this.isHideRevenue = await Account.isHideRevenue(
        this.userBelongType,
        this.userBelongId,
        this.userType,
      )
    },
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
}
.breadCrumb {
  margin-bottom: 20px;
}

.standard-title {
  margin-bottom: 30px;
  font-weight: normal;
  display: flex;
  align-items: center;
}

.title-selector {
  margin-right: 10px;
}

.chart-wrapper {
  padding: 10px 10px 20px;
}

.table-wrapper {
  margin: 30px 0 40px;
  padding: 30px 10px 10px;
}
</style>
